import { Pipe, PipeTransform } from '@angular/core';

let monthsArray: string[] = [
    'none',
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

function pad(n: number): string {
    return (n >= 10) ? "" + n : "0" + n;
}
function numberToDate(dateNumber: number): { year: number, month: number, day: number, date: Date } {
    let tempDateNumber = "" + dateNumber;
    return {
        year: Number(tempDateNumber.slice(0, 4)),
        month: Number(tempDateNumber.slice(4, 6)),
        day: Number(tempDateNumber.slice(6)),
        date: new Date(`${Number(tempDateNumber.slice(0, 4))}/${Number(tempDateNumber.slice(4, 6))}/${Number(tempDateNumber.slice(6))}`)
    }
}
function dateToNumber(date: Date): number {
    let dateNumber = `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
    return Number(dateNumber);
}

@Pipe({
    name: 'numberToDate'
})
export class NumberToDatePipe implements PipeTransform {
    transform(dateNumber: number, month: number = 1): string | null {
        let tempDateObj = numberToDate(dateNumber);
        if (month >= 1) {
            let oldDate: Date = new Date(tempDateObj.date);
            let newDate = new Date(oldDate.setMonth(oldDate.getMonth() + (month - 1)));
            //let newDate:any = new Date(tempDateObj.date.setMonth(tempDateObj.date.getMonth() + (month-1)));
            let newNumberDate = dateToNumber(newDate);
            let newDateObj = numberToDate(newNumberDate);
            return `${newDateObj.day}/${monthsArray[newDateObj.month]}/${newDateObj.year}`;
        } else {
            return null;
        }
    }
}
